<template>
  <div class="index">
    <el-container>
      <el-header class="header">
        <div class="hidden-sm-and-down header-block">
          <span :lg="{span:8,offset:4}" :md="{span:12,offset:0}" :sm="{span:12,offset:0}" class="header-logo">
              <img src="@/../static/iamges/home/home_logo.jpg">
              <img  @click="switchToEnglish" src="@/../static/iamges/language_en.png" style="width: 40px; height: 40px;cursor: pointer;">
          </span>
          <!-- <span :lg="{span:8,offset:4}" :md="{span:12,offset:0}" :sm="{span:12,offset:0}" style="display: flex;align-items: center;margin-left: 15px;cursor: pointer;">
              <img  @click="switchToEnglish" src="@/../static/iamges/language_en.png" style="width: 40px; height: 40px;">
          </span>  -->
          <span class="header-menu" :lg="{span:8,offset:4}" :md="{span:12,offset:0}" :sm="{span:12,offset:0}"
                style="margin-top: 22px">
            <el-menu ref="menu" class="el-menu-demo" mode="horizontal" router text-color="#000000"
                     :default-active='activeMenuIndex' active-text-color="#7b9d38" @select="handleSelect">
                <el-menu-item route="/homepage" :style="menuItemStyle[0]" index="0">首页</el-menu-item>
                <el-menu-item route="/aboutUs" index="3" :style="menuItemStyle[3]">关于我们</el-menu-item>
                <el-menu-item route="/shop/productList" index="1" :style="menuItemStyle[1]">产品中心</el-menu-item>
                <el-menu-item :style="menuItemStyle[4]">
                  <a style="display:flex;text-decoration: none;color: #606266;" href="https://scan.turingene.com/management/#/slideShare?id=1762242353758" target="_blank">云切片库</a>
                </el-menu-item>

                <!-- <el-submenu index="6" :style="menuItemStyle[6]" :class="{'submenu-selected': isSubmenuSelected}">
                  <template slot="title">云切片库</template>
                  <el-menu-item class="sub-menu-item">
                    <a style="display:flex;text-decoration: none;color: #606266;" href="https://scan.turingene.com/management/#/slideShare?id=1762242353758" target="_blank">2025样片(五代机)</a>
                  </el-menu-item>
                </el-submenu> -->
                <el-menu-item route="/recruit" :style="menuItemStyle[5]" index="5">人才招聘</el-menu-item>
                <el-menu-item route="/contactUs" :style="menuItemStyle[6]" index="6">联系我们</el-menu-item>
                <el-menu-item route="/download" :style="menuItemStyle[7]" index="7">相关下载</el-menu-item>
            </el-menu>
          </span>
          <div class="header-login">
            <span :lg="{span:4,offset:0}" :md="{span:0,offset:0}" :sm="{span:0,offset:0}" class="header-login">
              <a href="https://scan.turingene.com/management/" title="登录">
                <img src="@/../static/iamges/home/slide.svg">
              </a>
            </span>
          </div>
        </div>

        <!-- 手机端 -->
        <el-row class="hidden-md-and-up" style="display: flex;align-items: center;">
          <el-col :span="3" :offset="0" class="header-title header-logo">
            <img src="@/../static/iamges/home/home_logo.jpg">
            <img  @click="switchToEnglish" src="@/../static/iamges/language_en.png" style="width: 40px; height: 40px;cursor: pointer;">
          </el-col>
          <el-col :span="3" :offset="13">
            <a href="https://scan.turingene.com/management/" style="font-size: 20px" title="登录">
              <img src="@/../static/iamges/home/slide.svg">
            </a>
          </el-col>
          <el-col :span="2" :offset="3">
            <el-button @click="drawer = true" type="text" style="display: flex;align-items: center;">
              <i class="el-icon-menu" style="font-size: 30px;color: #282828"/>
            </el-button>
          </el-col>
        </el-row>
      </el-header>


      <el-main style="height: 100%;width: 100%;">
        <router-view v-on:handleSelect="handleSelect"/>
      </el-main>

      <!-- 智能助手按钮（保持现状） -->
      <div class="customer-service-btn" @click="openConsultDialog">
        <i class="el-icon-service"></i>
        <span>智能客服</span>
      </div>

      <!-- 智能助手弹窗组件 -->
      <online-consult-dialog :visible.sync="consultDialogVisible" />

      <div class="contactUs">
        <div class="left">
          <el-row>
            <el-col>
              <div style=" display: flex;  flex-direction: column;  align-items: center; ">
                <div><img src="@/../static/iamges/home/home_bottom1.jpg"></div>
                <div style=" display: flex; flex-direction: row; justify-content: space-between;margin-top: 20px; ">
                  <div style="margin-left: 32px;">
                    <img src="@/../static/iamges/home/home_bottom2.jpg">
                  </div>
                  <div style=" display: flex;  flex-direction: column;  align-items: center; margin-left: 15px">
                    <img src="@/../static/iamges/home/home_bottom3.jpg">
                    <span
                        style="text-align: center;color: #FFF;width: 209px;font-size: xx-small;margin-top: 10px;font-weight: bolder">
                      苏州迪美格智能科技有限公司<br/>版权所有
                    </span>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="right">
          <el-row style="margin-top: 15px">
            <el-row>
              <el-col :lg="{span:10,offset:2}" :md="{span:24,offset:0}">
                <el-row style="display: flex; align-items: center;">
                  <el-col :lg="{span:2}" :md="{span:1,offset:0}" :sm="{span:1,offset:8}"
                          :xs="{span:1,offset:8}" style="border: 1px solid  #d2d2d2"/>
                  <el-col class="contact-us-title" :lg="{span:10,offset:2}" :md="{span:5,offset:1}" :sm="{span:6}"
                          :xs="{span:6}" style="font-size: 24px;color: #ffffff;margin-left: 50px">联系我们
                  </el-col>
                  <el-col :lg="{span:2,offset:0}" :md="{span:1,offset:0}" :sm="{span:1}"
                          :xs="{span:1}" style="border: 1px solid #d2d2d2"/>
                </el-row>
              </el-col>
            </el-row>


            <el-col :lg="{span:8,offset:2}" :md="{span:24}" :sm="{span:24}" style="margin-top: 10px">
              <el-row class="contactUs-detail" v-for="(item,index) in contactUs" :key="index" style="margin-top: 15px">
                <el-col :lg="{span:2,offset:0}" :md="{span:2,offset:0}" :sm="{span:2,offset:3}">
                  <img :src="item.icon">
                </el-col>
                <el-col :lg="{span:5,offset:1}" :md="{span:14}" :sm="{span:14}" style="color: white;font-weight: 600;white-space: nowrap;
font-size: 14px;">
                  {{ item.text }}
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>


      <div class="footer">版权所有 : 苏州迪美格智能科技有限公司 &nbsp;
        <span>
          <a href="http://beian.miit.gov.cn" target="_blank" rel="nofollow"
             style="color: #666666;white-space: nowrap;text-decoration: none">
            苏ICP备17054065号
          </a>
        </span>
      </div>
    </el-container>

    <!--  以下内容暂时无效  -->
    <el-drawer :visible.sync="drawer" direction="rtl" :with-header="true" size="90%">
      <template slot="title">
        <span/>
      </template>
      <span>
        <el-menu ref="mobileMenu" :default-active='activeMenuIndex' router text-color="#000000"
                 active-text-color="#7b9d38" @select="handleSelect">
            <el-menu-item route="/homepage" :style="menuItemStyle[0]" index="0">首页</el-menu-item>
            <el-menu-item route="/aboutUs" index="3" :style="menuItemStyle[3]">关于我们</el-menu-item>
            <el-menu-item route="/shop/productList" index="1" :style="menuItemStyle[1]">产品中心</el-menu-item>
            <!-- <el-submenu index="6" :style="menuItemStyle[6]" :class="{'submenu-selected': isSubmenuSelected}">
              <template slot="title">云切片库</template>
              <el-menu-item>
                <a class="yun" style="text-decoration: none;color: #606266;" href="https://www.turingene.com/#/slideShow?id=3" target="_blank">2024病理年会读片会(四代机)</a>
              </el-menu-item>
              <el-menu-item>
                <a class="yun" style="text-decoration: none;color: #606266;" href="https://scan.turingene.com/management/#/slideShare?id=1762242353758" target="_blank">2025样片(五代机)</a>
              </el-menu-item>
            </el-submenu> -->
            <el-menu-item :style="menuItemStyle[4]">
                  <a style="display:flex;text-decoration: none;color: #606266;" href="https://scan.turingene.com/management/#/slideShare?id=1762242353758" target="_blank">云切片库</a>
            </el-menu-item>
            <el-menu-item route="/recruit" :style="menuItemStyle[5]" index="5">人才招聘</el-menu-item>
            <el-menu-item route="/contactUs" :style="menuItemStyle[6]" index="6">联系我们</el-menu-item>
            <el-menu-item route="/download" :style="menuItemStyle[7]" index="7">相关下载</el-menu-item>
        </el-menu>
      </span>
    </el-drawer>
  </div>
</template>
<script>
import OnlineConsultDialog from '@/components/OnlineConsultDialog.vue'

export default {
  name: "index",
  components: {
    OnlineConsultDialog
  },
  data() {
    return {
      activeIndex: '1',
      drawer: false,
      consultDialogVisible: false,
      menuSeleted: {backgroundColor: "#ffffff!important", color: "#7b9d38!important", fontSize: "30px"},
      menuUnSeleted: {backgroundColor: "#ffffff!important", color: "#818181!important", fontSize: "24px"},
      menuItemStyle: [
        this.menuSeleted,
        this.menuUnSeleted,
        this.menuUnSeleted,
        this.menuUnSeleted,
        this.menuUnSeleted,
        this.menuUnSeleted,
        this.menuUnSeleted,
        this.menuUnSeleted,
      ],
      contactUs: [
        {
          icon: require("@/../static/iamges/home/home_bottomicon1.png"),
          // text: "18121496883"
          text: "严经理：18921158967"
        },
        {
          icon: require("@/../static/iamges/home/home_bottomicon2.png"),
          //text: "江苏省苏州市工业园区仁爱路99号D2-410&411"
          text: "江苏省苏州市吴江区江陵街道Max科技园3栋图灵基因"
        },
        {
          icon: require("@/../static/iamges/home/home_bottomicon3.png"),
          text: "product@turingene.com"
        },
        {
          icon: require("@/../static/iamges/home/home_bottomicon4.png"),
          text: "www.turingene.com"
        },
      ],
    }
  },
  computed: {
    /**
     * 根据当前路由路径计算对应的菜单索引
     * 业务背景：Element UI 的 el-menu 需要 default-active 与菜单项的 index 匹配才能正确高亮
     * 设计决策：将路由路径映射到对应的菜单 index，确保刷新页面后菜单高亮状态正确
     * @returns {string} 返回对应的菜单 index 值
     */
    activeMenuIndex() {
      const path = this.$route.path;
      // 路径到菜单索引的映射关系
      if (path === '/homepage' || path === '/') {
        return '0';
      } else if (path.startsWith('/shop')) {
        // 商城相关路由（包括 /shop/productList, /shop/productDetail 等）
        return '1';
      } else if (path === '/aboutUs') {
        return '3';
      } else if (path === '/recruit') {
        return '5';
      } else if (path === '/contactUs') {
        return '6';
      } else if (path.startsWith('/download')) {
        // 相关下载页面及其子路由
        return '7';
      }
      // 默认返回首页索引
      return '0';
    },
    isSubmenuSelected() {
      // 检查云切片库是否应该显示为选中状态
      const style = this.menuItemStyle[6];
      return style && style.color === "#7b9d38!important";
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      // 重置所有菜单项为未选中状态
      this.menuItemStyle = [
        this.menuUnSeleted,
        this.menuUnSeleted,
        this.menuUnSeleted,
        this.menuUnSeleted,
        this.menuUnSeleted,
        this.menuUnSeleted,
        this.menuUnSeleted,
        this.menuUnSeleted,
      ];
      
      // 只设置被点击的菜单项为选中状态
      // keyPath[0] 是顶级菜单的 index
      if (keyPath && keyPath.length > 0) {
        const selectedIndex = parseInt(keyPath[0]);
        if (!isNaN(selectedIndex)) {
          // 点击的是菜单项，设置该菜单项为选中状态
          this.menuItemStyle[selectedIndex] = this.menuSeleted;
        }
      }
      
      // 关闭移动端抽屉
      this.drawer = false;
    },
    gtoSlide() {
      let id = 3;
      this.$router.push({
        query: {
          id: id,
        },
        path: "/slideShow"
      })
    },
    switchToEnglish() {
      window.location.href = 'https://www.turingene.com/en/';
    },
    // 打开咨询弹窗
    openConsultDialog() {
      this.consultDialogVisible = true;
    },
    /**
     * 根据当前路由路径初始化菜单选中状态
     * 业务背景：页面刷新或直接访问某个路由时，需要根据当前路径设置对应的菜单项为选中状态
     * 设计决策：在组件挂载和路由变化时都调用此方法，确保菜单高亮状态与当前路由保持一致
     */
    initMenuActiveState() {
      // 重置所有菜单项为未选中状态
      this.menuItemStyle = [
        this.menuUnSeleted,
        this.menuUnSeleted,
        this.menuUnSeleted,
        this.menuUnSeleted,
        this.menuUnSeleted,
        this.menuUnSeleted,
        this.menuUnSeleted,
        this.menuUnSeleted,
      ];
      
      // 根据当前路径设置对应的菜单项为选中状态
      const path = this.$route.path;
      if (path === '/homepage' || path === '/') {
        this.menuItemStyle[0] = this.menuSeleted;
      } else if (path.startsWith('/shop')) {
        // 商城相关路由（包括 /shop/productList, /shop/productDetail, /shop/orderConfirm 等）
        this.menuItemStyle[1] = this.menuSeleted;
      } else if (path === '/aboutUs') {
        this.menuItemStyle[3] = this.menuSeleted;
      } else if (path === '/recruit') {
        this.menuItemStyle[5] = this.menuSeleted;
      } else if (path === '/contactUs') {
        this.menuItemStyle[6] = this.menuSeleted;
      } else if (path.startsWith('/download')) {
        // 相关下载页面及其子路由
        this.menuItemStyle[7] = this.menuSeleted;
      }
    }
  },
  mounted() {
    this.$root.$index = this;
    // 组件挂载时初始化菜单选中状态
    this.initMenuActiveState();
  },
  watch: {
    /**
     * 监听路由变化，当路由改变时更新菜单选中状态
     * 业务背景：用户通过浏览器前进/后退按钮或直接修改 URL 时，菜单高亮状态需要同步更新
     * 设计决策：深度监听路由对象，确保路径变化时菜单状态能及时更新
     */
    '$route'() {
      this.initMenuActiveState();
    }
  }
}
</script>

<style scoped lang="css">
.contactUs {
  /*width: 100%;*/
  /*height: 280px;*/
  background-color: #7b9d38;
  padding-top: 20px;

}


/*小于992*/
@media only screen and (max-width: 992px) {


  .btn-group {
    flex-direction: column !important;
  }

  .footer {
    padding: 0px 15px;
  }

  .el-main {
    /*margin-top: 70px;*/
  }

  .el-header {
    height: 120px !important;
    padding-top: 0 !important;
    border-bottom: #7b9d38 10px solid;
  }

  .contactUs {
    text-align: center;
  }
}

/*大于992*/
@media only screen and (min-width: 992px) {
  .left, .right {
    width: 50%;
    height: 280px;
  }

  .contactUs {
    height: 280px;
    display: flex;
  }

  .btn-group {
    flex-direction: row !important;
  }

  .el-main {
    /*margin-top: 100px;*/
  }

  .el-header {
    height: 120px !important;
    padding-top: 0 !important;
    display: flex;
    justify-content: center;
    border-bottom: #7b9d38 10px solid;
  }

  .header-block {
    display: flex;
    width: 80vw;
    border-bottom: 5px solid #d0d0d0;
    justify-content: space-between;
  }

  .header-menu {
    display: flex;
    flex-direction: row-reverse;
  }
}


.header-title {
  font-size: 40px;
  font-weight: 800;
}

.header-logo {
  display: flex;                 /* 使用弹性布局，让内部元素共享同一基线 */
  align-items: center;           /* 垂直方向对齐到父容器中心，解决上下不齐的问题 */
  gap: 15px;                     /* 控制两个图标间距，可按需要微调，避免视觉拥挤 */
}

.el-main {
  text-align: center;
  padding: 0;

}

.el-menu .el-menu-item {
  font-size: 18px;
}

.el-menu .submenu_title {
  font-size: 18px !important;
}

.el-menu.el-menu--horizontal {
  border: none;
}

/* 云切片库菜单样式 - 与其他菜单项保持一致 */
.el-menu--horizontal .el-submenu /deep/ .el-submenu__title {
  color: #818181 !important;
  font-size: 24px !important;
  background-color: #ffffff !important;
  padding: 0 20px !important;
  height: 60px !important;
  line-height: 60px !important;
  border-bottom: none !important;
}

/* 去掉云切片库的下边框 */
.el-menu--horizontal .el-submenu {
  border-bottom: none !important;
}

/* 放大云切片库的下拉箭头图标 */
.el-menu--horizontal .el-submenu /deep/ .el-submenu__icon-arrow {
  font-size: 18px !important;
  margin-left: 5px !important;
}

.el-menu--horizontal .el-submenu /deep/ .el-submenu__title:hover {
  color: #7b9d38 !important;
  background-color: #ffffff !important;
}

/* 只有当云切片库被选中时才应用选中样式 */
.el-menu--horizontal .el-submenu.submenu-selected.is-opened /deep/ .el-submenu__title,
.el-menu--horizontal .el-submenu.submenu-selected.is-active /deep/ .el-submenu__title {
  color: #7b9d38 !important;
  font-size: 30px !important;
}

/* 如果云切片库未选中，即使打开也不应用选中样式 */
.el-menu--horizontal .el-submenu:not(.submenu-selected).is-opened /deep/ .el-submenu__title,
.el-menu--horizontal .el-submenu:not(.submenu-selected).is-active /deep/ .el-submenu__title {
  color: #818181 !important;
  font-size: 24px !important;
}

/* 移动端抽屉菜单中云切片库的标题样式 - 与其他菜单项保持一致 */
.el-menu:not(.el-menu--horizontal) .el-submenu /deep/ .el-submenu__title {
  color: #818181 !important;
  font-size: 24px !important;
  background-color: #ffffff !important;
  padding: 0 20px !important;
  height: 60px !important;
  line-height: 60px !important;
}

.el-menu:not(.el-menu--horizontal) .el-submenu.submenu-selected /deep/ .el-submenu__title {
  color: #7b9d38 !important;
  font-size: 30px !important;
}

/* 放大移动端抽屉菜单中云切片库的下拉箭头图标 */
.el-menu:not(.el-menu--horizontal) .el-submenu /deep/ .el-submenu__icon-arrow {
  font-size: 18px !important;
  margin-left: 5px !important;
}

/* 移动端抽屉菜单中云切片库的子菜单项字体稍大 */
.el-menu:not(.el-menu--horizontal) .el-submenu .el-menu-item {
  font-size: 20px !important;
}

/* 移动端抽屉菜单中云切片库子菜单项悬浮选中样式 */
.el-menu:not(.el-menu--horizontal) .sub-menu-item:hover {
  background-color: #e8f5e9 !important;
  color: #7b9d38 !important;
}

.el-menu:not(.el-menu--horizontal) .sub-menu-item:hover a {
  color: #7b9d38 !important;
  background-color: #e8f5e9 !important;
}

.el-submenu .el-menu-item {
  font-size: 16px;
}

.el-submenu .el-menu-item:hover {
  background-color: #f5f7fa !important;
  color: #7b9d38 !important;
}

.el-submenu .el-menu-item a {
  width: 100%;
  display: block;
}

.el-submenu .el-menu-item:hover a {
  color: #7b9d38 !important;
}

/* 云切片库子菜单项悬浮选中样式 */
.sub-menu-item:hover {
  background-color: #e8f5e9 !important;
  color: #7b9d38 !important;
}

.sub-menu-item:hover a {
  color: #7b9d38 !important;
  background-color: #e8f5e9 !important;
}


.el-menu {
  font-size: 18px;
}


.footer {
  display: flex;
  justify-content: center;
  background-color: #d0d0d0;
  height: 50px;
  line-height: 50px;
  color: #666666;
  font-weight: 500;
  font-size: 13px
}


/*    992-1200之间*/
@media screen and (min-width: 992px)and(max-width: 1200px) {
  .contactUs {
    display: flex;
    height: 280px;
    display: flex;
  }

  .left, .right {
    width: 50%;

  }

  .dmg-text {
    margin-left: -30px;
  }

}

/*    768-992之间*/
@media screen and (min-width: 768px)and(max-width: 992px) {
  .left, .right {
    width: 50%;

  }

  .contactUs {
    display: flex;
    height: 280px;
  }
}

/*    小于768*/
@media only screen and (max-width: 768px) {
  .header-title {
    font-size: 40px;
    font-weight: 800;

  }

  .header-logo {
    display: flex;                 /* 使用弹性布局，让内部元素共享同一基线 */
    align-items: center;           /* 垂直方向对齐到父容器中心，解决上下不齐的问题 */
    gap: 15px;                     /* 控制两个图标间距，可按需要微调，避免视觉拥挤 */
  }

  .el-main {
    /*margin-top: 60px;*/
  }

  .left, .right {
    width: 100%;
  }

  .contact-us-title {
    margin-left: 0px !important;
  }

  .footer {
    font-size: 10px !important;
  }
}

/* 禁用菜单项的过渡动画，避免切换时的闪烁 */
.el-menu--horizontal .el-menu-item,
.el-menu:not(.el-menu--horizontal) .el-menu-item {
  transition: none !important;
  border-bottom: 2px solid transparent !important;
}

.el-menu--horizontal >>> .el-menu-item.is-active {
  border-bottom: 2px solid transparent !important;
  /*color: #303133;*/
}

.yun:hover {
  color: rgb(129, 129, 129);
}

.yun:link {
  color: rgb(129, 129, 129);
}

.yun:visited {
  color: rgb(129, 129, 129);
}

.yun:active {
  color: #a0c15f;
}

.header-menu {
  flex-grow: 1;
}

.header-login {
  margin: 10px 0 0 0;
  white-space: nowrap; /* 防止链接换行 */
}

/* 智能助手按钮样式 */
.customer-service-btn {
  position: fixed;
  right: 0px;
  top: 80%;
  transform: translateY(-50%);
  z-index: 1000;
  background: linear-gradient(135deg, #7b9d38 0%, #5a7a2a 100%);
  color: white;
  padding: 15px 10px;
  border-radius: 8px 0 0 8px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(123, 157, 56, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  writing-mode: vertical-lr;
  text-orientation: upright;
  min-width: 25px;
}

.customer-service-btn:hover {
  background: linear-gradient(135deg, #5a7a2a 0%, #7b9d38 100%);
  box-shadow: 0 6px 16px rgba(123, 157, 56, 0.6);
  transform: translateY(-50%) scale(1.05);
}

.customer-service-btn i {
  font-size: 24px;
  margin-bottom: 8px;
}

.customer-service-btn span {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 2px;
}

/* 咨询弹窗样式 */
.consult-dialog {
  margin-top: 5vh !important;
}

.consult-dialog .el-dialog__header {
  background: linear-gradient(135deg, #7b9d38 0%, #5a7a2a 100%);
  padding: 15px 20px;
  border-radius: 4px 4px 0 0;
}

.consult-dialog .el-dialog__title {
  color: white;
  font-size: 18px;
  font-weight: 600;
}

.consult-dialog .el-dialog__headerbtn .el-dialog__close {
  color: white;
  font-size: 20px;
}

.consult-dialog .el-dialog__headerbtn .el-dialog__close:hover {
  color: #f0f0f0;
}

.dialog-title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
}

.dialog-title i {
  font-size: 20px;
}

.consult-content {
  display: flex;
  flex-direction: column;
  height: 500px;
}

.message-list {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background: #f5f5f5;
  border-radius: 4px;
  margin-bottom: 15px;
}

.message-item {
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
}

.message-item.sent {
  align-items: flex-end;
}

.message-item.received {
  align-items: flex-start;
}

.message-bubble {
  max-width: 70%;
  padding: 10px 15px;
  border-radius: 12px;
  word-wrap: break-word;
  line-height: 1.5;
}

.message-item.sent .message-bubble {
  background: #7b9d38;
  color: white;
  border-bottom-right-radius: 4px;
}

.message-item.received .message-bubble {
  background: white;
  color: #333;
  border-bottom-left-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.message-time {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
  padding: 0 5px;
}

.input-area {
  display: flex;
  flex-direction: column;
}

.input-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.input-footer .tip {
  font-size: 12px;
  color: #999;
}

/* 去掉弹窗遮罩层 */
::v-deep .consult-dialog {
  pointer-events: auto;
}

::v-deep .v-modal {
  display: none !important;
}

/* 确保弹窗可以交互 */
::v-deep .el-dialog__wrapper {
  pointer-events: none;
}

::v-deep .el-dialog__wrapper .consult-dialog {
  pointer-events: auto;
}

/* 响应式设计 */
@media only screen and (max-width: 768px) {
  .customer-service-btn {
    right: 0px;
    padding: 12px 8px;
    min-width: 25px;
  }
  
  .customer-service-btn i {
    font-size: 20px;
    margin-bottom: 6px;
  }
  
  .customer-service-btn span {
    font-size: 12px;
  }
  
  .consult-dialog {
    width: 90% !important;
    margin: 5vh auto !important;
  }
  
  .consult-content {
    height: 400px;
  }
}

</style>
